import { UiRecommendShareModel } from "../../models";

import {
    mockAdfDocument,
    mockAdfParagraph,
    mockAdfLink,
    mockAdfText
} from "./mock-adf-doc";

export function mockUiRecommendShareModel({
    id = "recommend-share-1234",
    type = "uiRecommendShare",
    locale = "en",
    content = mockUiRecommendShareModelContent()
}: Partial<UiRecommendShareModel> = {}): UiRecommendShareModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiRecommendShareModelContent = UiRecommendShareModel["content"];

export function mockUiRecommendShareModelContent({
    emailButtonLabel = "Email",
    facebookButtonLabel = "Share",
    label = "Your custom share link",
    loggedOutText = mockAdfDocument({
        content: [
            mockAdfParagraph({
                content: [
                    mockAdfText({
                        text: "Login",
                        marks: [
                            mockAdfLink({
                                attrs: { href: "/login?returnUrl=%2Frecommend" }
                            })
                        ]
                    }),
                    mockAdfText({
                        text: " and we’ll give you a link you can use to get credit for your referrals."
                    })
                ]
            })
        ]
    }),
    messages = [
        "You need @trello! It's like organization powered by rocket fuel. (And it's free!)"
    ],
    twitterButtonLabel = "Tweet"
}: Partial<UiRecommendShareModelContent> = {}): UiRecommendShareModelContent {
    return {
        emailButtonLabel,
        facebookButtonLabel,
        label,
        loggedOutText,
        messages,
        twitterButtonLabel
    };
}
